<form #adminForm="ngForm" class="admin-form" (ngSubmit)="onSubmit(adminForm)">
  <cei-panel class="admin-form-panel" [height]="'auto'">
    <div class="grid-container admin-pessoa-usuario-form__grade">
      <div class="col-6 admin-pessoa-usuario-form__coluna">
        <h3 class="admin-form-section__title">Dados da pessoa</h3>
        <cei-input-text
          label="Nome:"
          inputId="nome"
          name="nome"
          required
          [(ngModel)]="form.nome"
        />
        <cei-input-text
          label="CPF:"
          inputId="cpf"
          name="cpf"
          required
          cpf
          [mask]="cpfMask"
          [dropSpecialCharacters]="true"
          [(ngModel)]="form.cpf"
        />

        <cei-photo-upload
          [previewUrl]="form.fotoUrl"
          [showRemove]="!!form.fotoUrl || !!pessoaId"
          [maxSizeBytes]="maxFotoSizeBytes"
          (fileSelected)="onFotoSelected($event)"
          (removed)="onFotoRemoved()"
        />

        <h3 class="admin-form-section__title">Conta de usuário</h3>
        <cei-input-text
          label="Login:"
          inputId="login"
          name="login"
          [required]="exigeContaUsuario"
          [(ngModel)]="form.login"
        />
        <cei-input-text
          label="E-mail:"
          inputId="email"
          name="email"
          type="email"
          email
          [required]="exigeContaUsuario"
          [(ngModel)]="form.email"
        />
        <cei-input-text
          label="Senha:"
          inputId="password"
          name="password"
          type="password"
          [required]="exigeContaUsuario && mode === 'create'"
          [(ngModel)]="form.password"
        />

        <div class="checkbox-row admin-pessoa-usuario-form__flags">
          <cei-checkbox label="Ativo" inputId="is_active" name="is_active" [(ngModel)]="form.is_active" />
          <cei-checkbox label="Staff" inputId="is_staff" name="is_staff" [(ngModel)]="form.is_staff" />
        </div>
      </div>

      <div class="col-6 admin-pessoa-usuario-form__coluna admin-pessoa-usuario-form__coluna--direita">
        <section class="admin-form-section admin-pessoa-usuario-form__secao">
          <h3 class="admin-form-section__title">Permissões do Usuário</h3>
          @if (permissoesCatalogoCarregado && (mode === 'create' || formVersao > 0)) {
            @if (availablePermissions.length) {
              @for (chave of [chaveAutocompletePermissoes()]; track chave) {
                <cei-autocomplete-chips
                  class="admin-pessoa-usuario-form__autocomplete"
                  inputId="user_permissions"
                  name="user_permissions"
                  placeholder="Buscar permissão..."
                  [minSearchLength]="0"
                  [(ngModel)]="form.user_permissions"
                  [displayWith]="formatarPermissao"
                  [displayChipWith]="formatarPermissaoChip"
                  [extrairChave]="extrairChavePermissao"
                  rotuloChipsAcessibilidade="Permissões selecionadas"
                >
                  @for (permissao of availablePermissions; track permissao.id) {
                    <cei-autocomplete-option [value]="permissao">
                      {{ formatarPermissao(permissao) }}
                    </cei-autocomplete-option>
                  }
                </cei-autocomplete-chips>
              }
            } @else {
              <p class="admin-pessoa-usuario-form__vazio">Nenhuma permissão disponível.</p>
            }
          }
        </section>

        <section class="admin-form-section admin-pessoa-usuario-form__secao">
          <h3 class="admin-form-section__title">Grupos do Usuário</h3>
          @if (gruposCatalogoCarregado && (mode === 'create' || formVersao > 0)) {
            @if (availableGroups.length) {
              @for (chave of [chaveAutocompleteGrupos()]; track chave) {
                <cei-autocomplete-chips
                  class="admin-pessoa-usuario-form__autocomplete"
                  inputId="groups"
                  name="groups"
                  placeholder="ex: Empresa Júnior"
                  [minSearchLength]="0"
                  [(ngModel)]="form.groups"
                  [displayWith]="formatarGrupo"
                  [extrairChave]="extrairChaveGrupo"
                  rotuloChipsAcessibilidade="Grupos selecionados"
                >
                  @for (grupo of availableGroups; track grupo.id) {
                    <cei-autocomplete-option [value]="grupo">
                      {{ formatarGrupo(grupo) }}
                    </cei-autocomplete-option>
                  }
                </cei-autocomplete-chips>
              }
            } @else {
              <p class="admin-pessoa-usuario-form__vazio">Nenhum grupo disponível.</p>
            }
          }
        </section>
      </div>
    </div>
  </cei-panel>
  <div class="admin-content__actions">
    <cei-button type="submit">Salvar</cei-button>
  </div>
</form>
